import {
  ON_CHANGE_STYLE_PARAM,
  PREVIEW_HOVER_MODE,
  ON_TEXT_CHANGE,
  ON_SELECT_DESIGN_TAB,
} from '../constants';
import {
  BOOLEANS,
  NUMBERS,
  LAYOUT_PROFILE,
} from '../constants/settingsConstants';

const initState = {
  ...BOOLEANS,
  ...NUMBERS,
  isHeaderLayoutCenter: false,
  m_isHeaderLayoutCenter: false,
  helpId: 'eeb1c948-45a9-4b85-adc7-55eb8268f38f',
};

export default (state = initState, action) => {
  switch (action.type) {
    case ON_CHANGE_STYLE_PARAM:
      return {
        ...state,
        ...action.payload,
        isHeaderLayoutCenter:
          action.payload.headerLayout === LAYOUT_PROFILE.CENTER ? true : false,
        m_isHeaderLayoutCenter:
          action.payload.m_headerLayout === LAYOUT_PROFILE.CENTER
            ? true
            : false,
      };
    case PREVIEW_HOVER_MODE:
      if (state.isHoverMode === action.payload) {
        return state;
      }

      return {
        ...state,
        isHoverMode: action.payload,
      };
    case ON_TEXT_CHANGE:
      return {
        ...state,
        ...action.payload,
      };
    case ON_SELECT_DESIGN_TAB:
      return {
        ...state,
        helpId: action.payload,
      };
    default:
      return state;
  }
};
